module.exports = __webpack_public_path__ + "media/30.d0000780.mp3";